var $c6e46c2dfe8ac7b2$exports = {};
$c6e46c2dfe8ac7b2$exports = {
    "colorFormat": `Formato colore`,
    "hex": `Esadecimale`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$c6e46c2dfe8ac7b2$exports as default};
//# sourceMappingURL=it-IT.mjs.map
